import type { SubmitStatus } from 'app/developer-v3/types/statuses';
import type { SemVer } from 'app/developer-v3/types/version';
import { MIGRATE_EMAIL, MIGRATE_PERCENTAGE } from './constants';

export type MigrationType = typeof MIGRATE_PERCENTAGE | typeof MIGRATE_EMAIL;

export type PromoteForm = {
  reasons: {
    hasNewFeatures: boolean;
    hasBugFixes: boolean;
    [key: string]: boolean;
  };
  description: string;
};

export type Version = {
  appId: number;
  authorEmail: string;
  changelog?: string;
  createdAt: string;
  deployment: string;
  deprecationDate?: string;
  isGUIIntegration: boolean;
  platformVersion: string;
  submitStatus?: SubmitStatus;
  userCount: number;
  userCountUpdatedAt: number;
  updatedAt: string;
  version: SemVer;
};
